(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/betslip-selector-1x2/assets/javascripts/betslips/reducera.js') >= 0) return;  svs.modules.push('/components/tipsen/betslip-selector-1x2/assets/javascripts/betslips/reducera.js'); "use strict";

const {
  Betslip
} = svs.components.tipsen.betslipParts;
const {
  useSelector
} = ReactRedux;
const {
  selectReduceCount
} = svs.components.tipsen.engine.selectors.couponSelectors;
const {
  useBetslipContext
} = svs.components.tipsen.betslipParts;
const Reducera = () => {
  const {
    couponId
  } = useBetslipContext();
  const reducedCount = useSelector(state => selectReduceCount(state, couponId));
  const numRows = reducedCount;
  return React.createElement("div", {
    className: "pg_tipsen_content"
  }, React.createElement("span", {
    className: "pg_tipsen_betslip_system_info"
  }, React.createElement(Betslip.RowsViewReduce, {
    icon: "rows",
    numberOfRows: numRows,
    numRows: numRows
  }, React.createElement(Betslip.BetslipLabel, null))), React.createElement("span", {
    className: "pg_tipsen_betslip_price"
  }, "124 KR"), React.createElement("span", {
    className: "pg_tipsen_betslip_pay_button"
  }, "Betala"));
};
setGlobal('svs.components.tipsen.betslipParts.betslips.Reducera', Reducera);
 })(window);